import React from 'react';
import { Hero } from '../components/Hero';
import { Banner } from '../components/Banner';
import { DomainFocus } from '../components/DomainFocus';
import { Features } from '../components/Features';
import { OurPeople } from '../components/OurPeople';
import { CTA } from '../components/CTA';
export function Home() {
  return <main data-id="element-168">
      <Hero data-id="element-169" />
      <Banner data-id="element-170" />
      <DomainFocus data-id="element-171" />
      <Features data-id="element-172" />
      <OurPeople data-id="element-173" />
      <CTA data-id="element-174" />
    </main>;
}